<div class="card">
  <div class="card-header" style="border-bottom: none">
    <div class="card-title d-flex flex-column align-items-center">
      <h4 style="margin: 0">{{ data.title }}</h4>
    </div>
  </div>
  <div class="card-body">
    <div
      [id]="data.widgetId"
      [style.height]="data.height || '50vh'"
      [hidden]="hasError"
    ></div>
    <div style="display: flex; flex-direction: column; gap: 8px">
      <div
        style="display: flex; align-items: center; gap: 20px"
        [hidden]="hasError"
      >
        <!-- Planned Value Legend -->
        <div style="display: flex; align-items: center; gap: 5px">
          <div
            style="
              width: 2px;
              height: 10px;
              background: none;
              border-left: 2px dotted #444343cc;
            "
          ></div>
          <span>Planned Value</span>
        </div>

        <!-- Type Colors Legends -->
        <div style="display: flex; gap: 10px; flex-wrap: wrap">
          <div
            *ngFor="let type of typeKeys()"
            style="display: flex; align-items: center; gap: 5px"
          >
            <div
              [style.background]="typeColors[type]"
              style="width: 25px; height: 15px"
            ></div>
            <span>{{ type }}</span>
          </div>
        </div>
        
      </div>
    </div>

    <app-data-error *ngIf="hasError" [message]="errorMessage"></app-data-error>
  </div>
</div>
